import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { Info } from "@mui/icons-material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import {
  CustomButton,
  InfoMessage,
} from "components/CustomComponents/CustomButton";
import dayjs from "dayjs";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { showToast } from "services/utils/Status";
import { customGetAPI, customAPI } from "services/utils/CustomAPI";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import {
  Cancel,
  Done,
  Edit,
  Delete,
  AddCircleTwoTone,
} from "@material-ui/icons";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import {
  themes,
  tableRowSx,
  tableCellFontSize,
  optionalAvathar,
} from "services/constants";
import { Loader } from "components/Loader";
import { useDispatch } from "react-redux";
import { tooltipStyleProps } from "services/constants/Styles";
const keys = ["name", "minutes"];

export const TrackSettings = () => {
  const [selectedTime, setSelectedTime] = useState(null);
  const [type, setType] = useState("Apply To All Users");
  const { domain, token, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [timeError, setTimeError] = useState(false);
  const [triggerApi, setTriggerApi] = useState(true);
  const [triggerUserApi, serTriggerUserApi] = useState(true);
  const [updatedDetails, setUpdatedDetails] = useState([]);
  const [selectUserName, setSelectUserName] = useState("");
  const [selectData, setSelectData] = useState("");
  const [selectUserId, setSelectUserId] = useState("");
  const [userData, setUserData] = useState([]);
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [isAdding, setIsAdding] = useState(false);
  const [isdelete, setIsDelete] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [disableAddRow, setDisableAddRow] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [loader, setLoader] = useState(false);
  const containerRef = useRef(null);
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);

  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Settings",
    "Settings"
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleTimeChange = (newValue) => {
    setSelectedTime(newValue);
  };

  const headers = [
    { name: "Employee Name" },
    { name: "Minutes" },
    { name: "Action" },
  ];

  const selectType = (event) => {
    setType(event.target.value);
    setTimeError(false);
    setNameError(false);
    setTriggerApi(true);
    setEditRowIndex(null);
    serTriggerUserApi(true);
    setSelectedTime(null);
    if (event.target.value === "Apply To All Users") {
      setIsAdding(false);
    }
    dispatch(setGlobalSearchValue(""));
  };

  const applyGlobal = async () => {
    if (selectedTime !== null && selectedTime.minute() !== 0) {
      let payload = {
        user_id: 99999,
        name: "All Users",
        minutes: selectedTime ? selectedTime.minute() : 0,
      };
      const response = await customAPI(
        `${domain}tracking/auto-checkpoint-threshold/`,
        "PUT",
        payload
      );
      if (response.ok) {
        showToast("success", response?.responseDetails?.message);
        setTimeError(false);
        setTriggerApi(true);
        serTriggerUserApi(true);
      }
    } else {
      setTimeError(true);
    }
  };

  useEffect(() => {
    const getUpdatedDetails = async () => {
      const res = await customGetAPI(
        `${domain}tracking/auto-checkpoint-threshold/`
      );
      if (res?.ok) {
        const allUsersData = res.responseDetails.filter((element) => {
          return element.name !== "All Users";
        });
        setUpdatedDetails(allUsersData);
        const allUserMinutes = res.responseDetails.filter((element) => {
          return element.name === "All Users";
        });
        setSelectedTime(
          dayjs()
            .startOf("day")
            .add(allUserMinutes[0]?.minutes || 0, "minute")
        );
      }
    };
    if (triggerApi) {
      getUpdatedDetails();
      setTriggerApi(false);
    }
  }, [domain, token, triggerApi]);

  useEffect(() => {
    const getUserDetials = async () => {
      const res = await customGetAPI(
        `${domain}tracking/user-specific-threshold/`
      );
      if (res?.ok) {
        setUserData(res?.responseDetails);
      }
    };
    if (triggerUserApi) {
      getUserDetials();
      serTriggerUserApi(false);
    }
  }, [domain, token, triggerApi, triggerUserApi]);

  const updateUserName = (event, data) => {
    if (data) {
      setSelectUserName(data?.name);
      setSelectData(data);
      setSelectUserId(data?.id);
      setShowAutoCompleteAvathar(false);
    } else {
      setSelectUserName("");
      setSelectUserId("");
      setShowAutoCompleteAvathar(true);
    }
  };

  const applyIndividual = async () => {
    if (
      selectedTime !== null &&
      selectedTime.minute() !== 0 &&
      selectUserName !== ""
    ) {
      setLoader(true);
      let payload = {
        user_id: selectUserId,
        name: selectUserName,
        minutes: selectedTime ? selectedTime.minute() : 0,
        isdeleted: isdelete ? isdelete : false,
      };
      const response = await customAPI(
        `${domain}tracking/auto-checkpoint-threshold/`,
        "PUT",
        payload
      );
      if (response.ok) {
        showToast("success", response?.responseDetails?.message);
        setTimeError(false);
        setLoader(false);
        setNameError(false);
        setTriggerApi(true);
        setDisableAddRow(false);
        serTriggerUserApi(true);
        setSelectUserName("");
        setSelectUserId("");
        setIsAdding(false);
        setIsDelete(false);
        setEditRowIndex(null);
        setSelectedTime(null);
      }
    } else if (
      (selectedTime === null || selectedTime.minute() === 0) &&
      selectUserName === ""
    ) {
      setTimeError(true);
      setNameError(true);
    } else if (selectedTime === null || selectedTime.minute() === 0) {
      setTimeError(true);
      setNameError(false);
    } else if (selectUserName === "") {
      setTimeError(false);
      setNameError(true);
    }
  };

  const deleteData = async () => {
    let payload = {
      user_id: selectUserId,
      name: selectUserName,
      minutes: selectedTime ? selectedTime.minute() : 0,
      isdeleted: isdelete,
    };
    setLoader(true);
    const response = await customAPI(
      `${domain}tracking/auto-checkpoint-threshold/`,
      "PUT",
      payload
    );
    if (response.ok) {
      showToast("error", response?.responseDetails?.message);
      setIsDelete(false);
      setSelectUserName("");
      setLoader(false);
      setDisableAddRow(false);
      setSelectUserId("");
      setSelectedTime(null);
      setTriggerApi(true);
      serTriggerUserApi(true);
      setOpen(false);
    }
  };

  const closePopup = () => {
    setOpen(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (updatedDetails?.length !== 0) {
      const filteredResults = updatedDetails?.filter((item) =>
        keys.some((key) =>
          item[key]
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase())
        )
      );
      setSearchData(filteredResults);
      setPage(globalSearchValue ? 0 : page);
    }
  }, [globalSearchValue, page, updatedDetails]);

  // useEffect(() => {
  //   scrollTop(containerRef);
  // }, [page]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.Grid container sx={{ ml: 4, mt: 0.5 }}>
          <Mui.Typography
            sx={{ fontWeight: "bold", fontSize: 25, paddingTop: 1 }}
          >
            Tracking / Settings
          </Mui.Typography>
        </Mui.Grid>
        <Mui.Grid
          container
          sx={{
            border: `2px solid ${themes.sidebarDivider}`,
            borderRadius: "10px 10px 10px 10px",
            ml: 4,
            mr: 4,
            mt: 2,
            padding: 3,
          }}
        >
          <Mui.Grid container>
            <Mui.Typography sx={{ fontWeight: "bold", fontSize: 25 }}>
              Checkpoint Threshold Duration &nbsp;
              <Mui.Tooltip
                arrow
                slotProps={tooltipStyleProps}
                title="Define the maximum allowed time interval between checkpoints"
              >
                <Info />
              </Mui.Tooltip>
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid container sx={{ mt: 2, ml: 2 }}>
            <Mui.RadioGroup
              row
              onChange={selectType}
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={type}
              name="radio-buttons-group"
            >
              <Mui.FormControlLabel
                label="Apply To All Users"
                value="Apply To All Users"
                control={<Mui.Radio />}
              />

              <Mui.FormControlLabel
                label="User-Specific Settings"
                value="User-Specific Settings"
                control={<Mui.Radio />}
              />
            </Mui.RadioGroup>
          </Mui.Grid>
          {type === "Apply To All Users" ? (
            <Mui.Grid container sx={{ mt: 3, ml: 3 }}>
              <Mui.Grid container spacing={2}>
                <Mui.Grid item sx={{ mt: 1.5 }}>
                  <Mui.Typography sx={{ fontSize: 20, fontWeight: 700 }}>
                    Global Thershold &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="If an employee stays at a location longer than the set time, the system will automatically register it as a checkpoint. This applies globally unless a specific override is configured and minutes should be less than 60."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>

                <Mui.Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <TimePicker
                        ampm={false}
                        views={["minutes"]}
                        value={selectedTime}
                        onChange={handleTimeChange}
                        viewRenderers={{
                          minutes: renderTimeViewClock,
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            width: 15,
                          },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Mui.Grid>
                {timeError && (
                  <Mui.Typography
                    variant="body2"
                    color="error"
                    sx={{ fontSize: 13, paddingTop: 0.5 }}
                  >
                    Minutes is required
                  </Mui.Typography>
                )}

                <Mui.Grid item sx={{ mt: 2 }}>
                  <Mui.Typography sx={{ fontSize: 19 }}>minutes</Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>

              <Mui.Grid container sx={{ mt: 4 }}>
                <Mui.Grid
                  item
                  xs={4.45}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <CustomButton
                    actionName="Submit"
                    typeName="button"
                    actionFuntion={() => {
                      if (check_access) {
                        applyGlobal();
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to modify the minutes`
                        );
                      }
                    }}
                  />
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container sx={{ mt: 3 }}></Mui.Grid>
            </Mui.Grid>
          ) : (
            <Mui.Grid container sx={{ mt: 3, ml: 3 }}>
              <Mui.Grid sx={{ mt: 1.5 }}>
                <Mui.Typography sx={{ fontSize: 20, fontWeight: 700 }}>
                  Personal Threshold &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="If an employee stays in one place longer than this time, it will be marked as a checkpoint.This setting applies only to that employee and minutes should be less than 60."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid container sx={{ mt: 0.3 }}>
                <Mui.Typography sx={{ fontSize: 16, fontWeight: 700, mt: 1.5 }}>
                  Choose user and their user level threshold
                </Mui.Typography>
              </Mui.Grid>
              {loader ? (
                <Loader />
              ) : (
                <Mui.Grid container sx={{ mt: 0.3 }}>
                  <Mui.TableContainer
                    ref={containerRef}
                    component={Mui.Paper}
                    sx={{
                      mt: 2,
                      width: "84%",
                      ml: 10,
                      mr: 5,
                      maxHeight: 510,
                    }}
                  >
                    <Mui.Table>
                      <Mui.TableHead
                        sx={{
                          backgroundColor: themes.primary,
                          position: "sticky",
                          top: -1,
                          zIndex: 10,
                        }}
                      >
                        <Mui.TableRow
                          maxWidth="xl"
                          align="center"
                          sx={tableRowSx}
                        >
                          {headers?.map?.((value, index) => (
                            <Mui.TableCell
                              key={index}
                              sx={{
                                color: themes.headLine,
                                fontWeight: "bold",
                                fontSize: tableCellFontSize,
                                width: "33%",
                              }}
                            >
                              {value?.name}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      </Mui.TableHead>
                      <Mui.TableBody>
                        {isAdding && (
                          <Mui.TableRow
                            maxWidth="xl"
                            align="center"
                            sx={tableRowSx}
                          >
                            <Mui.TableCell>
                              <Mui.Grid container sx={{ mt: 1 }}>
                                <CustomAutoCompleteWithLogo
                                  dataList={userData.map((obj) => ({
                                    ...obj,
                                    label: obj.name,
                                    image: obj?.image_url,
                                  }))}
                                  selectedValue={selectData}
                                  updateDataFunction={updateUserName}
                                  placeHolder="Select the employee name"
                                  showAvathar={showAutoCompleteAvathar}
                                  setShowAutoCompleteAvathar={
                                    setShowAutoCompleteAvathar
                                  }
                                />
                              </Mui.Grid>
                              {nameError && (
                                <Mui.Typography
                                  variant="body2"
                                  color="error"
                                  sx={{
                                    fontSize: 13,
                                    paddingTop: 0.5,
                                  }}
                                >
                                  Employee name is required
                                </Mui.Typography>
                              )}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["TimePicker"]}>
                                  <TimePicker
                                    ampm={false}
                                    views={["minutes"]}
                                    value={selectedTime}
                                    onChange={handleTimeChange}
                                    viewRenderers={{
                                      minutes: renderTimeViewClock,
                                    }}
                                    slotProps={{
                                      textField: { size: "small" },
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                              {timeError && (
                                <Mui.Typography
                                  variant="body2"
                                  color="error"
                                  sx={{
                                    fontSize: 13,
                                    paddingTop: 0.5,
                                  }}
                                >
                                  Minutes is required
                                </Mui.Typography>
                              )}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              <Mui.IconButton onClick={() => applyIndividual()}>
                                <Done sx={{ color: themes.primaryIndicator }} />
                              </Mui.IconButton>
                              <Mui.IconButton
                                onClick={() => {
                                  setIsAdding(false);
                                  setSelectUserName("");
                                  setSelectUserId("");
                                  setSelectedTime(null);
                                  setTimeError(false);
                                  setNameError(false);
                                  setDisableAddRow(false);
                                }}
                              >
                                <Cancel sx={{ color: themes.redColor }} />
                              </Mui.IconButton>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        )}
                        {searchData?.length === 0 && !isAdding ? (
                          <InfoMessage dataLength={updatedDetails} />
                        ) : (
                          searchData
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((value, index) => (
                              <Mui.TableRow
                                key={index}
                                maxWidth="xl"
                                align="center"
                                sx={tableRowSx}
                              >
                                {editRowIndex === index ? (
                                  <>
                                    <Mui.TableCell sx={{ paddingBottom: 0.5 }}>
                                      {value?.name}
                                    </Mui.TableCell>
                                    <Mui.TableCell>
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DemoContainer
                                          components={["TimePicker"]}
                                        >
                                          <TimePicker
                                            ampm={false}
                                            views={["minutes"]}
                                            value={selectedTime}
                                            onChange={handleTimeChange}
                                            viewRenderers={{
                                              minutes: renderTimeViewClock,
                                            }}
                                            slotProps={{
                                              textField: { size: "small" },
                                            }}
                                          />
                                        </DemoContainer>
                                      </LocalizationProvider>

                                      {timeError && (
                                        <Mui.Typography
                                          variant="body2"
                                          color="error"
                                          sx={{
                                            fontSize: 13,
                                            paddingTop: 0.5,
                                          }}
                                        >
                                          Minutes is required
                                        </Mui.Typography>
                                      )}
                                    </Mui.TableCell>
                                    <Mui.TableCell sx={{ width: "10%" }}>
                                      <Mui.IconButton
                                        onClick={() => applyIndividual(index)}
                                      >
                                        <Done
                                          sx={{
                                            color: themes.primaryIndicator,
                                            strokeWidth: 2,
                                          }}
                                        />
                                      </Mui.IconButton>
                                      <Mui.IconButton
                                        onClick={() => {
                                          setEditRowIndex(null);
                                          setSelectUserName("");
                                          setSelectUserId("");
                                          setSelectedTime(null);
                                          setTimeError(false);
                                          setNameError(false);
                                          setDisableAddRow(false);
                                        }}
                                      >
                                        <Cancel
                                          sx={{
                                            color: themes.redColor,
                                            strokeWidth: 2,
                                          }}
                                        />
                                      </Mui.IconButton>
                                    </Mui.TableCell>
                                  </>
                                ) : (
                                  <>
                                    <Mui.TableCell sx={{ width: "33%" }}>
                                      <Mui.Stack direction="Row">
                                        <Mui.Avatar
                                          sx={{ width: 23, height: 23 }}
                                          alt={value?.name
                                            ?.charAt(0)
                                            .toUpperCase()}
                                          src={
                                            value?.image_url ?? optionalAvathar
                                          }
                                        />
                                        &nbsp;
                                        {value?.name}
                                      </Mui.Stack>
                                    </Mui.TableCell>
                                    <Mui.TableCell sx={{ width: "33%" }}>
                                      {value?.minutes}
                                    </Mui.TableCell>
                                    <Mui.TableCell sx={{ width: "33%" }}>
                                      <>
                                        <Mui.IconButton
                                          onClick={() => {
                                            if (check_access) {
                                              setEditRowIndex(index);
                                              setSelectUserName(value?.name);
                                              setSelectUserId(value?.user_id);
                                              setDisableAddRow(true);
                                              setSelectedTime(
                                                dayjs()
                                                  .startOf("day")
                                                  .add(
                                                    value?.minutes || 0,
                                                    "minute"
                                                  )
                                              );
                                            } else {
                                              showToast(
                                                "error",
                                                `Access denied: You are not authorized to edit the user time`
                                              );
                                            }
                                          }}
                                          disabled={isAdding}
                                        >
                                          <Edit
                                            sx={{
                                              color: isAdding
                                                ? themes.disable
                                                : themes.primaryIndicator,
                                              strokeWidth: 2,
                                            }}
                                          />
                                        </Mui.IconButton>

                                        <Mui.IconButton disabled={isAdding}>
                                          <Delete
                                            onClick={() => {
                                              if (check_access) {
                                                setSelectUserName(value?.name);
                                                setSelectUserId(value?.user_id);
                                                setSelectedTime(
                                                  dayjs()
                                                    .startOf("day")
                                                    .add(
                                                      value?.minutes || 0,
                                                      "minute"
                                                    )
                                                );
                                                setIsDelete(true);
                                                setOpen(true);
                                              } else {
                                                showToast(
                                                  "error",
                                                  `Access denied: You are not authorized to delete the users`
                                                );
                                              }
                                            }}
                                            sx={{
                                              color: isAdding
                                                ? themes.disable
                                                : themes.redColor,
                                              strokeWidth: 2,
                                            }}
                                          />
                                        </Mui.IconButton>
                                      </>
                                    </Mui.TableCell>
                                  </>
                                )}
                              </Mui.TableRow>
                            ))
                        )}
                      </Mui.TableBody>
                    </Mui.Table>
                  </Mui.TableContainer>
                  <Mui.Grid container>
                    <Mui.Grid item xs={0.69}></Mui.Grid>
                    <Mui.Grid item xs={5.7}>
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title={"Add Row"}
                      >
                        <Mui.IconButton
                          variant="contained"
                          color="primary"
                          sx={{
                            color:
                              disableAddRow || isAdding
                                ? themes.disable
                                : themes.headLine,
                            strokeWidth: 2,
                          }}
                          onClick={() => {
                            if (check_access) {
                              setIsAdding(true);
                              setDisableAddRow(false);
                              setSelectedTime(null);
                              setSelectData("");
                              if (containerRef.current) {
                                containerRef.current.scrollTop = 0;
                              }
                            } else {
                              showToast(
                                "error",
                                `Access denied: You are not authorized to add the users`
                              );
                            }
                          }}
                          disabled={disableAddRow || isAdding}
                        >
                          <AddCircleTwoTone />
                        </Mui.IconButton>
                      </Mui.Tooltip>
                    </Mui.Grid>
                    <Mui.Grid item xs={4.5}>
                      {searchData?.length > 10 && (
                        <Mui.TablePagination
                          className="custom-pagination"
                          rowsPerPageOptions={[10, 20, 50, 100]}
                          component="div"
                          count={searchData?.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      )}
                    </Mui.Grid>
                  </Mui.Grid>
                </Mui.Grid>
              )}
            </Mui.Grid>
          )}
        </Mui.Grid>
      </Mui.Grid>
      <GlobalDialogBox
        open={open}
        handleCloseDialog={closePopup}
        title={"Delete"}
      >
        <Mui.Grid container>
          <Mui.Typography sx={{ fontSize: 22 }}>
            Do you want to remove the employee details?
          </Mui.Typography>
        </Mui.Grid>
        <Mui.Grid container sx={{ paddingTop: 2, justifyContent: "flex-end" }}>
          <CustomButton
            actionFuntion={() => closePopup()}
            actionName="No"
            typeName="submit"
          />
          &nbsp;&nbsp;
          <CustomButton
            actionFuntion={() => {
              deleteData();
            }}
            actionName="Yes"
            typeName="submit"
          />
        </Mui.Grid>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
